import moment from 'moment';
import React, { useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import { UseControllerProps, useController } from 'react-hook-form';
import { FaCalendarAlt } from 'react-icons/fa';
import { DATE_HYPHEN_FORMAT } from 'utils';

export type DateRangeControlProps = UseControllerProps<any> & {
  placeholder: string;
};

function DateRangeControl(props: DateRangeControlProps) {
  const { placeholder } = props;
  const {
    field: { value, onChange },
  } = useController(props);
  const CustomInput = React.forwardRef((props: any, ref: any) => {
    return (
      <div style={{ position: 'relative' }}>
        <FaCalendarAlt style={{ position: 'absolute', top: '8px', left: '10px' }} onClick={props.onClick} />
        <input
          className="form-control"
          onClick={props.onClick}
          style={{ paddingLeft: '32px' }}
          value={props.value}
          onChange={props.onChange}
          readOnly
          placeholder={props.placeholder}
          type="text"
        />
      </div>
    );
  });

  const [dateRange, setDateRange] = useState<Array<Date | null>>([
    value.busy_season_start ? new Date(value.busy_season_start) : null,
    value.busy_season_start ? new Date(value.busy_season_end) : null,
  ]);
  const [startDate, endDate] = dateRange;

  return (
    <div>
      <ReactDatePicker
        selectsRange={true}
        startDate={startDate}
        endDate={endDate}
        dateFormat="yyyy/MM/dd"
        onChange={(update) => {
          setDateRange(update);
          onChange({
            ...value,
            busy_season_start: update[0] ? moment(update[0]).format(DATE_HYPHEN_FORMAT) : null,
            busy_season_end: update[1] ? moment(update[1]).format(DATE_HYPHEN_FORMAT) : null,
          });
        }}
        placeholderText={placeholder}
        isClearable={true}
        customInput={<CustomInput />}
      />
    </div>
  );
}

export default DateRangeControl;
